import type { ExecuteInstruction } from '@cosmjs/cosmwasm-stargate';

import type { IMultiMintAsset, IUpdateMultiTags } from '@/services';

import type {
  DataInputExecuteInstruction,
  DataInputMultiMint,
  DataMint,
  ItemAsset,
} from './useMintAsset';

export const isPassRule = (data?: DataMint): boolean => {
  if (!data) return false;
  return Boolean(data.description) && Boolean(data.name) && Boolean(data.royalty);
};

export const isCurrentSelect = (data: ItemAsset, assetSelected: ItemAsset | null) =>
  data.id === assetSelected?.id;

export const filterDataPassRule = (list: ItemAsset[]) =>
  list.filter((item) => isPassRule(item.dataMint));

export const hasDataPassRule = (list: ItemAsset[]) => filterDataPassRule(list).length > 0;

export const getDataExecuteInstruction = (
  data: DataInputExecuteInstruction[],
): ExecuteInstruction[] => {
  return data.map((dt) => ({
    contractAddress: dt.contractMarketplace,
    msg: {
      mint_nft: {
        mint: {
          mint: {
            name: dt.asset.name,
            image: dt.asset.image,
            owner: dt.asset.owner,
            token_id: dt.asset.tokenId,
            description: dt.asset.description,
            prompt_hash: '',
          },
        },
        creator: dt.creator,
        ai_royalty: dt.royalty,
        creator_type: 'provider',
        contract_addr: dt.contractOwner,
      },
    },
  }));
};

export const convertDataFormToMintData = (data: ItemAsset[]): DataInputMultiMint[] => {
  return data.map((dt) => ({
    royalty: dt.dataMint?.royalty ?? '0',
    creator: dt.creator || '',
    processId: dt.id,
    asset: {
      name: dt.dataMint?.name ?? '',
      image: dt.originalUrl,
      description: dt.dataMint?.description ?? '',
      owner: dt.creator || '',
      tokenId: dt.id.toString(),
      tags: dt.dataMint?.tags,
    },
  }));
};

export const convertDataFormToQueueData = (data: ItemAsset[]): IMultiMintAsset[] => {
  return data.map((dt) => ({
    id: dt.id,
    details: {
      name: dt.dataMint?.name ?? '',
      description: dt.dataMint?.description ?? '',
      royalty: dt.dataMint?.royalty ? Number(dt.dataMint?.royalty) : 0,
    },
  }));
};

export const toDataUpdateMultiAssetTags = (data: DataInputMultiMint[]): IUpdateMultiTags[] => {
  const dataHasTags = data.filter((item) => item.asset.tags && item.asset.tags.length > 0);
  return dataHasTags.map((dt) => ({
    assetId: Number(dt.asset.tokenId),
    tags: dt.asset?.tags ? dt.asset.tags.map((tag) => ({ content: tag.label })) : [],
  }));
};
